export default "__VITE_ASSET__uPmafqoY__"